import RegionTable from "./details-table"

const Region = ({data}: any) => {
    return ( 
        <div>
            <RegionTable data={data}/>
        </div>
     );
}
 
export default Region;